module.exports = __webpack_public_path__ + "static/media/cq_simulatore b.ff8e717c.svg";